import _ from "lodash";

import ability from "@/services/ability";

// Utility method for checking authorization of a route using an object with
// action/subject keys. Both action and subject keys can be strings or
// functions returning a string.
//
// This function checks for authorization metadata in *all* matched routes,
// starting from the root. If any fail authorization it is considered an
// authorization failure for the entire route.
export default function isRouteForbidden(route) {
	const forbidden = _.map(route.matched, match => {
		const authMeta = _.get(match, "meta.auth");

		if (_.isNil(authMeta)) return false; // No authorization required
		if (_.isFunction(authMeta)) return !authMeta(route);

		let forbidden = false;

		try {
			let { action, subject } = authMeta;
			if (_.isFunction(action)) action = action(route);
			if (_.isFunction(subject)) subject = subject(route);
			if (!ability.can(action, subject)) {
				const rule = ability.relevantRuleFor(action, subject);
				forbidden = rule && rule.reason ? rule.reason : true;
			}
		} catch (e) {
			// Unexpected error thrown while attempting to authorize navigation
			window.vm.$bugsnagClient.notify(e);
			forbidden = `Unexpected error while attempting to authorize navigation to (${route.path}): ${e.message}`;
		}

		if (forbidden && !_.isString(forbidden)) {
			// Default forbidden "reason" for when none is provided by CASL
			forbidden = "Unauthorized";
		}

		return forbidden;
	}).filter(_.identity);

	return forbidden.length ? forbidden.join("; ") : false;
}
